<template>
  <h3>概念板块</h3>
    <!-- 使用 Element Plus 按钮 -->
    <el-button
      v-for="btn in buttons"
      :key="btn.type"
      @click="handleClick(btn.type)"
      :type="btn.elType"
      :class="['button', btn.class]"
      plain
    >
      {{ btn.text }}
    </el-button>

 <!-- 自定义查询链接 -->
  <div class="custom-links-container">
    <div class="custom-links">
      <a
        v-for="(link, index) in customLinks"
        :key="index"
        :href="link.url"
        target="_blank"
        class="link-item"
      >
        {{ link.text }}
      </a>
    </div>
  </div>

    <div class="label-container">
      <div class="label">
        <a
          v-for="link in fixedLinks"
          :key="link.code"
          :href="link.url"
          target="_blank"
          class="label-link"
        >
          {{ link.text }}
        </a>
      </div>
    </div>

    <!-- 加载/错误提示 -->
    <div v-if="loading" class="loading-indicator">正在加载...</div>
    <div v-if="error" class="error-message">{{ error }}</div>

    <!-- 链接分组 -->
    <div v-for="(group, index) in linkGroups" :key="index" class="category">
      <div class="cate_group">
        <div class="cate_letter">{{ group.letter }}</div>
        <div class="cate_items">
          <a
            v-for="(link, linkIndex) in group.links"
            :key="linkIndex"
            :href="link.code"
            target="_blank"
            class="link-item"
          >
            <el-icon><Link /></el-icon>{{ link.text }}
          </a>
        </div>
      </div>
    </div>

</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import { ElButton, ElIcon } from 'element-plus';
import { Link } from '@element-plus/icons-vue';
import _ from 'lodash';

export default defineComponent({
  name: 'GnLinkList',
  components: {
    ElButton,
    ElIcon,
    Link
  },
  data() {
    return {
      linkGroups: [],
      customLinks: [
        {
        text: '同花顺热板',
        url: 'https://www.iwencai.com/unifiedwap/result?w=%E5%90%8C%E8%8A%B1%E9%A1%BA%E7%83%AD%E6%9D%BF&querytype=stock',
      },
      {
        text: '同花顺财报分析',
        url: 'https://board.10jqka.com.cn/gateway/visual/searchNewPage#source=tssy',
      },
      {
        text: '均线多头排列',
        url: 'https://www.iwencai.com/unifiedwap/result?w=%E5%9D%87%E7%BA%BF%E5%A4%9A%E5%A4%B4%E6%8E%92%E5%88%97&querytype=stock',
      },
        {
        text: '均线多头排列,2日连续流入，排名前30的人气股',
        url: `https://www.iwencai.com/unifiedwap/result?w=%E5%9D%87%E7%BA%BF%E5%A4%9A%E5%A4%B4%E6%8E%92%E5%88%97,2%E6%97%A5%E8%BF%9E%E7%BB%AD%E6%B5%81%E5%85%A5%EF%BC%8C%E6%8E%92%E5%90%8D%E5%89%8D30%E7%9A%84%E4%BA%BA%E6%B0%94%E8%82%A1%EF%BC%8C&querytype=stock`
      },

      {
        text: '均线多头排列,三日连续流入，排名前20的人气股',
        url: `https://www.iwencai.com/unifiedwap/result?w=%E5%9D%87%E7%BA%BF%E5%A4%9A%E5%A4%B4%E6%8E%92%E5%88%97,%E4%B8%89%E6%97%A5%E8%BF%9E%E7%BB%AD%E6%B5%81%E5%85%A5%EF%BC%8C%E6%8E%92%E5%90%8D%E5%89%8D20%E7%9A%84%E4%BA%BA%E6%B0%94%E8%82%A1%EF%BC%8C&querytype=stock`
      },
      {
        text: '永赢先进制造智选混合发起C',
        url: 'https://fund.10jqka.com.cn/fefund/fundAssetTrace/ifundapp_web/public/positionReview.html?fundCode=018125&fundName=%E6%B0%B8%E8%B5%A2%E5%85%88%E8%BF%9B%E5%88%B6%E9%80%A0%E6%99%BA%E9%80%89%E6%B7%B7%E5%90%88%E5%8F%91%E8%B5%B7C&share=true&share_jjid=825BF41E-B232-4BF0-BBAF-5385031E66BE&share_userid=kdfFz&back_source=wxhy&share_hxapp=isdk',
      },
      {
        text: '同花顺热榜',
        url: `https://eq.10jqka.com.cn/frontend/thsTopRank/index.html?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no#/`
      },

     {
        text: '人气排名前100',
        url: `https://basic.10jqka.com.cn/basicph/popularityRanking.html?client_userid=kdfFz&back_source=wxhy&share_hxapp=isc&fontzoom=no
`
      },


      {
        text: '龙虎榜',
        url: 'https://data.10jqka.com.cn/market/longhu/'
      },
      {
        text: '3日资金流入资金5000万,股价大于8元小于15元,机器人概念',
        url: `https://www.iwencai.com/unifiedwap/result?w=${encodeURIComponent('3日资金流入资金5000万,股价大于8元小于12元,机器人概念')}&querytype=stock`
      },
      {
        text: '昨日换手率大于3%，股价8元-12元，机器人概念,三日资金流入',
        url: `https://www.iwencai.com/unifiedwap/result?w=${encodeURIComponent('昨日换手率大于2%，股价8元-12元，机器人概念,三日资金流入')}&querytype=stock`
      },
      {
        text: '上一交易日流入量大于3000万，股价大于8元小于15元，机器人概念',
        url: `https://www.iwencai.com/unifiedwap/result?w=${encodeURIComponent('上一交易日流入量大于3000万，股价大于8元小于15元，机器人概念')}&querytype=stock`
      },
      {
        text: '固态电池概念',
        url: `https://q.10jqka.com.cn/gn/detail/code/308294/`
      }
    ],
      buttons: [
        {
          type: 'gn',
          text: '同花顺行业',
          class: 'hot-list-button',
          elType: 'danger' // 对应element-plus的danger类型
        },
        {
          type: 'thshy',
          text: '概念',
          class: 'ext-list-button',
          elType: 'warning'
        },
        {
          type: 'zjhhy',
          text: '证监会行业',
          class: 'etf-list-button',
          elType: 'info'
        },
        {
          type: 'dy',
          text: '地域',
          class: 'update-stock-button',
          elType: 'success'
        },
        {
          type: 'zs',
          text: '指数',
          class: 'text-list-button',
          elType: 'primary'
        }
      ],
      fixedLinks: [
        {
          text: '机器人50指数',
          url: 'https://q.10jqka.com.cn/zs/detail/code/399283/'
        },
        {
          text: 'AI 50指数',
          url: 'https://q.10jqka.com.cn/zs/detail/code/399284/'
        },
        {
          text: '人形机器人',
          url: 'https://q.10jqka.com.cn/gn/detail/code/309119/'
        },
        {
          text: '低空经济',
          url:'http://q.10jqka.com.cn/gn/detail/code/309115/'
        },
        {
          text: '算力租赁',
          url:'https://q.10jqka.com.cn/gn/detail/code/309068/'
        },
        {
          text: '养老概念',
          url:'https://q.10jqka.com.cn/gn/detail/code/301494/'
        },
        {
          text: '小米汽车',
          url:'https://q.10jqka.com.cn/gn/detail/code/309106/'
        },
        {
          text: '华为汽车',
          url:'https://q.10jqka.com.cn/gn/detail/code/308507/'
        },
        {
          text: '华为鲲鹏',
          url:'https://q.10jqka.com.cn/gn/detail/code/308883/'
        },
        {
          text: '华为昇腾',
          url:'https://q.10jqka.com.cn/gn/detail/code/309090/'
        },
        {
          text: '华为概念 885806',
          url:'https://q.10jqka.com.cn/gn/detail/code/301459/'
        },
        {
          text: '阿里巴巴概念 885611',
          url:'https://q.10jqka.com.cn/gn/detail/code/301558/'
        },
        {
          text: '脑机接口 308535',
          url:'https://q.10jqka.com.cn/gn/detail/code/308535/'
        }

      ],


      loading: false,
      error: null,
      cache: {}
    };
  },
  methods: {
    async fetchData(type) {
      try {
        this.loading = true;
        this.error = null;
        if (this.cache[type]) {
          this.linkGroups = this.cache[type];
          return;
        }
        const response = await axios.get(`/api/${type}`);
        this.linkGroups = response.data;
        this.cache[type] = response.data;
      } catch (error) {
        this.error = `加载失败：${error.message}`;
      } finally {
        this.loading = false;
      }
    },
    handleClick(type) {
      this.debouncedFetch(type);
    },
    debouncedFetch: _.debounce(function(type) {
      this.fetchData(type);
    }, 300)
  },
  created() {
    this.fetchData('gn');
  }
});
</script>

<style scoped>
:root {
  --red: #dc3545;
  --orange: #ffc107;
  --gray: #6c757d;
  --green: #28a745;
  --blue: #007bff;
}

.container {
  margin: auto;
  padding: 20px;
  max-width: 1200px;
}

/* Element Plus 按钮样式覆盖 */
.button {
  margin-right: 10px;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

 ::v-deep .el-button {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

::v-deep .el-button--primary {
  background: linear-gradient(135deg, #4e79a7, #76c7c0);
  color: white;
  border: none;
}

::v-deep .el-button--primary:hover {
  background: linear-gradient(135deg, #76c7c0, #4e79a7);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
/* 图标样式 */
.el-icon {
  margin-right: 5px;
}


/* 固定链接样式 */
.label-container {
  margin: 20px 0;
}

.label {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  gap: 10px;
}

.label-link {
  color: var(--blue);
  text-decoration: none;
  font-weight: bold;
}

.label-link:hover {
  text-decoration: underline;
}

/* 加载/错误提示 */
.loading-indicator, .error-message {
  padding: 15px;
  margin: 20px 0;
  border-radius: 4px;
}
.loading-indicator { background: #f8d7da; color: #721c24; }
.error-message { background: #fff3cd; color: #856404; }

/* 链接分组样式 */
.category {
  margin-bottom: 20px;
}

.cate_group {
  display: flex;
  align-items: flex-start;
}

.cate_letter {
  font-weight: bold;
  font-size: 1.2em;
  margin-right: 20px;
}

.cate_items {
  flex: 1;
}

.link-item {
  display: inline-block;
  margin-bottom: 5px;
  color: var(--blue);
  text-decoration: none;
}

.link-item:hover {
  text-decoration: underline;
}

.bi {
  margin-right: 5px;
}
/* 新增样式 */
.custom-links {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.link-item {
  display: inline-block;
  padding: 8px 15px;
  background-color: #f0f0f0;
  border-radius: 4px;
  text-decoration: none;
  color: var(--blue);
  transition: all 0.3s;
}

.link-item:hover {
  background-color: #e0e0e0;
}

</style>
